import { WithNavigationWatcher } from "@/iti-core-react/contexts/navigation";
import { lazy } from "react";
import { Navigate } from "react-router-dom";
import Recycle from "./pages/Recycle/Recycle";

const Dashboard = lazy(() => import("@/pages/Dashboard/Dashboard"));

const CatalogueList = lazy(
	() => import("@/pages/Catalogue/CatalogueList/CatalogueList"),
);
const CatalogueDetail = lazy(
	() => import("@/pages/Catalogue/CatalogueDetail/CatalogueDetail"),
);
const FederatedCatalogueDetail = lazy(
	() =>
		import(
			"@/pages/DataspaceManagement/FederatedCatalogueDetail/FederatedCatalogueDetail"
		),
);
const CatalogueForm = lazy(
	() => import("@/pages/Catalogue/CatalogueForm/CatalogueForm"),
);
const DatabaseConnectionForm = lazy(
	() =>
		import("@/pages/Catalogue/DatabaseConnectionForm/DatabaseConnectionForm"),
);

const GlossaryList = lazy(
	() => import("@/pages/Glossary/GlossaryManagement/GlossaryManagement"),
);
const DataspaceManagement = lazy(
	() => import("@/pages/DataspaceManagement/DataspaceManagement"),
);
const GlossaryDetail = lazy(
	() => import("@/pages/Glossary/GlossaryDetail/GlossaryDetail"),
);
const GlossaryTermsImport = lazy(
	() =>
		import(
			"@/pages/Glossary/GlossaryDetail/GlossaryTermsImport/GlossaryTermsImport"
		),
);
const AutomationCards = lazy(
	() => import("@/pages/Automation/AutomationCards/AutomationCards"),
);
const AutomationDetail = lazy(
	() => import("@/pages/Automation/AutomationDetail/AutomationDetail"),
);
const OrganizationForm = lazy(
	() =>
		import(
			"@/pages/WisephereManagement/Organization/OrganizationForm/OrganizationForm"
		),
);
const ExperimentationView = lazy(
	() =>
		import("@/pages/Experimentation/ExperimentationView/ExperimentationView"),
);
const ExperimentationForm = lazy(
	() =>
		import("@/pages/Experimentation/ExperimentationForm/ExperimentationForm"),
);
const ReceivedDatasetShareRequestsList = lazy(
	() =>
		import(
			"@/pages/PermissionsManagement/ReceivedRequestsView/ReceivedRequestsView"
		),
);
const SentDatasetShareRequestsList = lazy(
	() =>
		import("@/pages/PermissionsManagement/SentRequestsView/SentRequestsView"),
);
const CategoryView = lazy(
	() => import("@/pages/Configuration/Category/CategoryView"),
);
const GlobalParametersView = lazy(
	() =>
		import(
			"@/pages/Configuration/GlobalParameters/GlobalParametersView/GlobalParametersView"
		),
);
const OrganizationManagementView = lazy(
	() => import("@/pages/OrganizationManagement/OrganizationManagementView"),
);
const ActivityManagementView = lazy(
	() => import("@/pages/Activity/ActivityManagementView"),
);
const NotificationList = lazy(
	() => import("@/pages/Notification/NotificationList/NotificationList"),
);
const InvitationForm = lazy(() => import("@/pages/Invitation/Invitation"));
const VSCodeViewer = lazy(() => import("@/pages/VSCodeViewer/VSCodeViewer"));

const ProfileForm = lazy(
	() => import("@/pages/Profile/ProfileForm/ProfileForm"),
);
const InvitationProfileList = lazy(
	() => import("@/pages/Profile/InvitationProfileList/InvitationProfileList"),
);
const RoleChangeSentRequestList = lazy(
	() =>
		import("@/pages/Profile/RoleChangeSentRequest/RoleChangeSentRequestView"),
);

const RoleChangeRequestView = lazy(
	() =>
		import(
			"@/pages/OrganizationManagement/RoleChangeRequest/RoleChangeRequestView/RoleChangeRequestView"
		),
);

const SecondStepContainer = lazy(
	() =>
		import(
			"@/pages/Catalogue/CatalogueForm/SecondStep/SecondStepContainer.tsx"
		),
);

const OrganizationView = lazy(
	() =>
		import(
			"@/pages/WisephereManagement/Organization/OrganizationView/OrganizationView"
		),
);
const InvitationView = lazy(
	() =>
		import(
			"@/pages/WisephereManagement/Invitation/InvitationView/InvitationView"
		),
);
const UserManagementView = lazy(
	() =>
		import(
			"@/pages/WisephereManagement/UserManagement/UserManagementView/UserManagementView"
		),
);

const LegalConditionsManagementTabs = lazy(
	() => import("@/pages/LegalConditions/LegalConditionsManagementTabs"),
);
const LegalConditionsDetail = lazy(
	() =>
		import(
			"@/pages/LegalConditions/LegalConditionManagement/LegalConditionsDetail/LegalConditionsDetail"
		),
);
const Identity = lazy(() => import("@/pages/Identity/Identity"));
const CredentialCreateView = lazy(
	() => import("@/pages/Identity/CredentialCreateView/CredentialCreateView"),
);
const CredentialDetailsView = lazy(
	() => import("@/pages/Identity/CredentialDetailsView/CredentialDetailsView"),
);
const ConnectorsView = lazy(
	() => import("@/pages/MasterManagement/Connectors/ConnectorsView"),
);
const CreateConnectorView = lazy(
	() => import("@/pages/MasterManagement/Connectors/CreateConnectorView"),
);
const UpdateConnectorView = lazy(
	() => import("@/pages/MasterManagement/Connectors/UpdateConnectorView"),
);
const AccessRightsView = lazy(
	() => import("@/pages/MasterManagement/AccessRights/AccessRightsView"),
);
const DetailAccessRightView = lazy(
	() => import("@/pages/MasterManagement/AccessRights/DetailAccessRightView"),
);
const CorporateIdentity = lazy(
	() =>
		import("@/pages/WisephereManagement/CorporateIdentity/CorporateIdentity"),
);
const DatasetSharing = lazy(
	() => import("@/pages/Catalogue/DatasetSharing/DatasetSharing"),
);

export class RouteDto {
	path: string;
	element: JSX.Element;
	data: {
		isInMenu: boolean;
	};
}

export const routes: RouteDto[] = [
	{
		path: "/legal-conditions",
		element: <LegalConditionsManagementTabs />,
		data: { isInMenu: false },
	},
	{
		path: "/legal-conditions/:tab",
		element: <LegalConditionsManagementTabs />,
		data: { isInMenu: false },
	},
	{
		path: "/legal-conditions/doc/new",
		element: <LegalConditionsDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/legal-conditions/doc/:id/:version?",
		element: <LegalConditionsDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/invitation/:guid",
		element: <InvitationForm />,
		data: { isInMenu: false },
	},
	{
		path: "/dashboard",
		element: <Dashboard />,
		data: { isInMenu: false },
	},
	{
		path: "/user-profile",
		element: <ProfileForm />,
		data: { isInMenu: false },
	},
	{
		path: "/invitation-request",
		element: <InvitationProfileList />,
		data: { isInMenu: false },
	},
	{
		path: "/role-changing",
		element: <RoleChangeSentRequestList />,
		data: { isInMenu: false },
	},
	{
		path: "/role-changing-organization",
		element: <RoleChangeRequestView />,
		data: { isInMenu: false },
	},
	{
		path: "/catalogues",
		element: <CatalogueList />,
		data: { isInMenu: true },
	},
	{
		path: "/catalogue/:id/:tab/*",
		element: <CatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/automations/:automationId/catalogue/:id",
		element: <CatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/automations/:automationId/catalogue/:id/:tab/*",
		element: <CatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/recycle-bin/catalogue/:id/:tab",
		element: <CatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/federated-catalogue/:datasetId",
		element: <FederatedCatalogueDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/dataset/:datasetId",
		element: <CatalogueForm />,
		data: { isInMenu: false },
	},
	{
		path: "/dataset/:datasetId/sharing",
		element: <DatasetSharing />,
		data: { isInMenu: false },
	},
	{
		path: "/dataset/:datasetId/artifact/:artifactId",
		element: <CatalogueForm />,
		data: { isInMenu: false },
	},
	{
		path: "/database-connection/:datasetId",
		element: <DatabaseConnectionForm />,
		data: { isInMenu: false },
	},
	{
		path: "/glossaries",
		element: <GlossaryList />,
		data: { isInMenu: true },
	},
	{
		path: "/glossaries/:id",
		element: <GlossaryDetail />,
		data: { isInMenu: true },
	},
	{
		path: "/glossaries/:id/import-terms",
		element: <GlossaryTermsImport />,
		data: { isInMenu: false },
	},
	{
		path: "/dataspaces",
		element: <DataspaceManagement />,
		data: { isInMenu: true },
	},
	{
		path: "recycle-bin/glossaries/:id",
		element: <GlossaryDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/automations",
		element: <AutomationCards />,
		data: { isInMenu: true },
	},
	{
		path: "/automations/:id/:idDataset?/:backToCatalogue?",
		element: <AutomationDetail />,
		data: { isInMenu: false },
	},
	{
		path: "/organization/:id?",
		element: <OrganizationForm />,
		data: { isInMenu: true },
	},
	{
		path: "recycle-bin/organization/:id?",
		element: <OrganizationForm />,
		data: { isInMenu: true },
	},
	{
		path: "/experimentation",
		element: <ExperimentationView />,
		data: { isInMenu: true },
	},
	{
		path: "/experimentation/:id",
		element: <ExperimentationForm />,
		data: { isInMenu: true },
	},
	{
		path: "/experimentation/VSCodeViewer/:experimentId/:deploymentId",
		element: <VSCodeViewer />,
		data: { isInMenu: false },
	},
	{
		path: "/received-dataset-share",
		element: <ReceivedDatasetShareRequestsList />,
		data: { isInMenu: false },
	},
	{
		path: "/sent-dataset-share",
		element: <SentDatasetShareRequestsList />,
		data: { isInMenu: false },
	},
	{
		path: "/configuration-parameters",
		element: <GlobalParametersView />,
		data: { isInMenu: false },
	},
	{
		path: "/categories",
		element: <CategoryView />,
		data: { isInMenu: false },
	},
	{
		path: "/activity",
		element: <ActivityManagementView />,
		data: { isInMenu: true },
	},
	{
		path: "/notifications",
		element: <NotificationList />,
		data: { isInMenu: true },
	},
	{
		path: "/management/tenant",
		element: <OrganizationManagementView />,
		data: { isInMenu: false },
	},
	{
		path: "/organization-management",
		element: <OrganizationView />,
		data: { isInMenu: false },
	},
	{
		path: "/personalization",
		element: <CorporateIdentity />,
		data: { isInMenu: false },
	},
	{
		path: "/usermanagement",
		element: <UserManagementView />,
		data: { isInMenu: false },
	},
	{
		path: "/invitation",
		element: <InvitationView />,
		data: { isInMenu: false },
	},
	{
		path: "/second-step/:datasetId",
		element: <SecondStepContainer />,
		data: { isInMenu: false },
	},
	{
		path: "/recycle-bin",
		element: <Recycle />,
		data: { isInMenu: false },
	},
	{
		path: "/recycle-bin/:tab",
		element: <Recycle />,
		data: { isInMenu: false },
	},
	{
		path: "/credentials",
		element: <Identity />,
		data: { isInMenu: false },
	},
	{
		path: "/credentials/credential/new",
		element: <CredentialCreateView />,
		data: { isInMenu: false },
	},
	{
		path: "/credentials/credential/details/:credentialId",
		element: <CredentialDetailsView />,
		data: { isInMenu: false },
	},
	{
		path: "/connectors",
		element: <ConnectorsView />,
		data: { isInMenu: false },
	},
	{
		path: "/connectors/new",
		element: <CreateConnectorView />,
		data: { isInMenu: false },
	},
	{
		path: "/connectors/edit/:connectorId",
		element: <UpdateConnectorView />,
		data: { isInMenu: false },
	},
	{
		path: "/access_rights",
		element: <AccessRightsView />,
		data: { isInMenu: false },
	},
	{
		path: "/access-rights/detail/:accessRightId",
		element: <DetailAccessRightView />,
		data: { isInMenu: false },
	},
	{
		path: "",
		element: window.self !== window.top ? <CatalogueList /> : <Dashboard />,
		data: { isInMenu: false },
	},
	{
		path: "*",
		element:
			window.self !== window.top ? (
				<Navigate to="/catalogues" />
			) : (
				<Navigate to="/dashboard" />
			),
		data: { isInMenu: false },
	},
];

const wrapNavigationWatcher = (route: RouteDto) => ({
	path: route.path,
	element: (
		<WithNavigationWatcher currentPath={route.path} component={route.element} />
	),
});

export default routes.map(wrapNavigationWatcher);
